import loadingGif from "../../assets/loading.gif";
import styled from "styled-components";

const LoadingGif = styled.div.attrs(() => ({
    style: {
        backgroundImage: `url(${loadingGif})`,
    },
}))`
    width: 35px;
    height: 35px;
    background-size: cover;
    background-position: center;
`;

export default LoadingGif;
